import type { IEventEmitter, Events, Listener } from '../common/types';

class EventEmitter implements IEventEmitter {
  private readonly events: Events = {};

  public on(event: string, listener: Listener): EventEmitter {
    if (typeof this.events[event] === 'undefined') {
      this.events[event] = listener;
    }
    return this;
  }

  public emit(event: string, ...args: any[]): void {
    if (typeof this.events[event] === 'function') {
      this.events[event].apply(this, args);
    }
  }

  public removeListener(event: string): void {
    if (typeof this.events[event] !== 'undefined') {
      delete this.events[event];
    }
  }
}

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default EventEmitter;
